import { z } from 'zod'
import { schemas } from '@repo/contracts'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'

// Response schemas are generated Go-first from the backend handler annotations
// (see contracts/). Do not hand-edit; run `task contracts` after changing the
// Go structs. `.describe()` only labels parse-error messages.
export const ProjectUserResponseSchema = schemas.apihttp_ProjectUserResponse.describe('ProjectUserResponse')

// GetUserProjectsV2 returns projects with their members.
export const ProjectResponseSchema = schemas.apihttp_ProjectWithMembersResponse.describe('ProjectResponse')

export const GetProjectsResponseSchema = z.array(ProjectResponseSchema).describe('GetProjectsResponse')

export type ProjectUserApiResponse = z.infer<typeof ProjectUserResponseSchema>
export type ProjectApiResponse = z.infer<typeof ProjectResponseSchema>

export async function getProjects(): Promise<Array<ProjectApiResponse>> {
  const res = await fetch('/api/projects/v2', {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), GetProjectsResponseSchema)
}
